import { useState, useEffect, useCallback } from 'react';
import { getAllLayouts } from '../services/firebase';

export function useAvailability(beachCode) {
  const [availabilityMap, setAvailabilityMap] = useState({});
  const [loading, setLoading] = useState(true);

  const fetchAll = useCallback(async () => {
    if (!beachCode) return;
    setLoading(true);
    try {
      const snapshots = await getAllLayouts(beachCode);
      const map = {};
      snapshots.forEach((snap) => {
        if (snap.dateStr) {
          map[snap.dateStr] = snap;
        }
      });
      // Crea un nuovo oggetto per forzare il re-render
      setAvailabilityMap({ ...map });
    } catch (e) {
      console.error('Errore disponibilità:', e);
    } finally {
      setLoading(false);
    }
  }, [beachCode]);

  useEffect(() => {
    fetchAll();
  }, [fetchAll]);

  const getLayoutForDate = (dateStr) => {
    return availabilityMap[dateStr]?.layout || [];
  };

  const getStatsForDate = (dateStr) => {
    const layout = getLayoutForDate(dateStr);
    const free = layout.filter((s) => s.status === 'free').length;
    const occupied = layout.filter((s) => s.status === 'occupied').length;
    return { free, occupied, total: layout.length };
  };

  return { availabilityMap, loading, refetch: fetchAll, getLayoutForDate, getStatsForDate };
}